import React from 'react';

// Número de WhatsApp (formato internacional sin '+', ej. 52 + 10 dígitos).
// Configurable por variable de entorno; si no, usa el número por defecto.
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '523111055812';
const WHATSAPP_MESSAGE = 'Hola, me gustaría más información sobre sus productos y servicios.';

const WhatsAppFloat = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/30 hover:scale-110 transition-transform duration-300"
    >
      <span className="absolute inline-flex w-full h-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <svg viewBox="0 0 32 32" className="relative w-8 h-8 fill-white" aria-hidden="true">
        <path d="M16.004 0h-.008C7.174 0 .002 7.174.002 16c0 3.498 1.13 6.74 3.05 9.377L1.05 31.05l5.86-1.873A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.826 32 16S24.826 0 16.004 0zm9.31 22.6c-.386 1.09-1.92 1.994-3.14 2.257-.834.178-1.922.32-5.588-1.197-4.69-1.943-7.71-6.71-7.945-7.02-.225-.31-1.894-2.522-1.894-4.81 0-2.29 1.2-3.416 1.63-3.884.353-.386.94-.56 1.5-.56.18 0 .343.01.49.017.43.018.646.043.93.723.353.85 1.208 2.977 1.312 3.192.106.216.176.47.036.78-.13.31-.246.44-.472.677-.226.237-.44.42-.666.677-.207.226-.44.47-.19.9.25.43 1.11 1.83 2.383 2.964 1.64 1.46 2.99 1.913 3.47 2.13.353.157.78.122 1.06-.183.354-.386.79-1.028 1.234-1.664.31-.44.7-.494 1.11-.34.42.144 2.66 1.253 3.11 1.48.45.226.75.34.86.53.11.19.11 1.1-.276 2.19z" />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
